module.exports = __webpack_public_path__ + "static/media/grupo-vip.15c47570.jpeg";